// extracted by mini-css-extract-plugin
export default {"login-page":"LoginPage_login-page__x7yl5","form":"LoginPage_form__jP5-C","logo":"LoginPage_logo__0cl9g"};